import { privateApi } from 'services';
import { TalentApplication } from './types';

const fetchTalentApplications = async (talentId: string): Promise<TalentApplication[]> =>
    privateApi.get<TalentApplication[]>(`talents/${talentId}/applications`);

export const TalentApplicationsGateway = {
    fetchTalentApplications,
};
